import React from 'react';
import NotAvailable from '../Common/NotAvailable';

export interface Education {
  institute: string;
  degree: string;
  year: string;
}

interface ProviderEducationSectionProps {
  education: Education[];
  licenseNumber: string | null;
}

const ProviderEducationSection: React.FC<ProviderEducationSectionProps> = ({
  education,
  licenseNumber,
}) => {
  return (
    <div className="grid grid-cols-2 gap-8">
      <section className="mb-6">
        <h4 className="font-['Ovo'] text-lg text-[#1f1f1f] uppercase mb-3">EDUCATION & TRAINING</h4>
        {education.length === 0 ? (
          <NotAvailable className="text-sm" />
        ) : (
          <div className="space-y-3">
            {education.map((edu, index) => (
              <div key={index} className="text-sm font-['Open_Sans'] text-[#767472]">
                {edu.institute && <p className="font-semibold text-[#1f1f1f]">{edu.institute}</p>}
                {edu.degree && <p>{edu.degree}</p>}
                {edu.year && <p>{edu.year}</p>}
              </div>
            ))}
          </div>
        )}
      </section>

      <section className="mb-6">
        <h4 className="font-['Ovo'] text-lg text-[#1f1f1f] uppercase mb-3">LICENSES</h4>
        {licenseNumber ? (
          <div className="text-sm font-['Open_Sans'] text-[#767472]">
            <p className="font-semibold text-[#1f1f1f]">License #{licenseNumber}</p>
          </div>
        ) : (
          <NotAvailable className="text-sm" />
        )}
      </section>
    </div>
  );
};

export default ProviderEducationSection;
